var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tab3/icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 7C3.75 5.61497 4.09637 4.57535 4.7371 3.88534C5.36848 3.20538 6.39295 2.75 8 2.75H16C17.607 2.75 18.6315 3.20538 19.2629 3.88534C19.9036 4.57535 20.25 5.61497 20.25 7V17C20.25 18.385 19.9036 19.4246 19.2629 20.1147C18.6315 20.7946 17.607 21.25 16 21.25H8C6.39295 21.25 5.36848 20.7946 4.7371 20.1147C4.09637 19.4246 3.75 18.385 3.75 17V7ZM8 1.25C6.10705 1.25 4.63152 1.79462 3.6379 2.86466C2.65363 3.92465 2.25 5.38503 2.25 7V17C2.25 18.615 2.65363 20.0754 3.6379 21.1353C4.63152 22.2054 6.10705 22.75 8 22.75H16C17.893 22.75 19.3685 22.2054 20.3621 21.1353C21.3464 20.0754 21.75 18.615 21.75 17V7C21.75 5.38503 21.3464 3.92465 20.3621 2.86466C19.3685 1.79462 17.893 1.25 16 1.25H8ZM15.25 4.5C15.25 4.08579 14.9142 3.75 14.5 3.75C14.0858 3.75 13.75 4.08579 13.75 4.5V6.5C13.75 8.01421 14.9858 9.25 16.5 9.25H18.5C18.9142 9.25 19.25 8.91421 19.25 8.5C19.25 8.08579 18.9142 7.75 18.5 7.75H16.5C15.8142 7.75 15.25 7.18579 15.25 6.5V4.5ZM7.25 13C7.25 12.5858 7.58579 12.25 8 12.25H12C12.4142 12.25 12.75 12.5858 12.75 13C12.75 13.4142 12.4142 13.75 12 13.75H8C7.58579 13.75 7.25 13.4142 7.25 13ZM8 16.25C7.58579 16.25 7.25 16.5858 7.25 17C7.25 17.4142 7.58579 17.75 8 17.75H16C16.4142 17.75 16.75 17.4142 16.75 17C16.75 16.5858 16.4142 16.25 16 16.25H8Z",
    fill: "#999999"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApp);
export default __webpack_public_path__ + "static/media/app.ef597e16997dbbf38823ca719866ef04.svg";
export { ForwardRef as ReactComponent };